import type { UseFormReturn } from 'react-hook-form';
import { asRecord, str } from '../../../platform/api/utils';
import {
  type CreateForm,
  TYPE_LABELS,
  PAYMENT_LABELS,
  Field,
  inputCss,
  primaryBtn,
  secondaryBtn,
  modalOverlay,
  modalStyle,
} from './finance-list.support';

export function FinanceCreateModal(props: {
  form: UseFormReturn<CreateForm>;
  categoriesForType: Record<string, unknown>[];
  selectedType: string;
  showNewCategory: boolean;
  setShowNewCategory: (v: boolean | ((prev: boolean) => boolean)) => void;
  newCatName: string;
  setNewCatName: (v: string) => void;
  createCategory: {
    isPending: boolean;
    mutate: (
      data: { name: string; type: string },
      opts: { onSuccess: (created: unknown) => void },
    ) => void;
  };
  createPending: boolean;
  onCancel: () => void;
  onCreate: () => void;
}) {
  const {
    form,
    categoriesForType,
    selectedType,
    showNewCategory,
    setShowNewCategory,
    newCatName,
    setNewCatName,
    createCategory,
    createPending,
    onCancel,
    onCreate,
  } = props;

  return (
    <div
      style={modalOverlay}
      onClick={(ev) => {
        if (ev.target === ev.currentTarget) onCancel();
      }}
    >
      <div style={modalStyle}>
        <h3 style={{ margin: '0 0 1rem', fontSize: '1rem' }}>Novo lançamento</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
            <Field label="Tipo">
              <select {...form.register('type')} style={inputCss}>
                {Object.entries(TYPE_LABELS).map(([v, l]) => (
                  <option key={v} value={v}>
                    {l}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Valor" error={form.formState.errors.amount?.message}>
              <input
                {...form.register('amount')}
                style={inputCss}
                type="number"
                step="0.01"
                placeholder="0,00"
              />
            </Field>
          </div>
          <Field label="Descrição" error={form.formState.errors.description?.message}>
            <input {...form.register('description')} style={inputCss} />
          </Field>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
            <Field label="Categoria">
              <select {...form.register('categoryId')} style={inputCss}>
                <option value="">Nenhuma</option>
                {categoriesForType.map((c) => (
                  <option key={str(c.id)} value={str(c.id)}>
                    {str(c.name)}
                  </option>
                ))}
              </select>
              <button
                type="button"
                onClick={() => {
                  setShowNewCategory((v) => !v);
                  setNewCatName('');
                }}
                style={{
                  ...secondaryBtn,
                  marginTop: 6,
                  fontSize: '0.75rem',
                  padding: '0.3rem 0.6rem',
                }}
              >
                + Nova categoria
              </button>
            </Field>
            <Field label="Método de pagamento">
              <select {...form.register('paymentMethod')} style={inputCss}>
                <option value="">Selecione...</option>
                {Object.entries(PAYMENT_LABELS).map(([v, l]) => (
                  <option key={v} value={v}>
                    {l}
                  </option>
                ))}
              </select>
            </Field>
          </div>
          {showNewCategory && (
            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-end' }}>
              <Field label={`Nome da categoria (${TYPE_LABELS[selectedType] ?? selectedType})`}>
                <input
                  value={newCatName}
                  onChange={(e) => {
                    setNewCatName(e.target.value);
                  }}
                  style={inputCss}
                  placeholder="Ex.: Transporte, Doações..."
                />
              </Field>
              <button
                type="button"
                disabled={!newCatName.trim() || createCategory.isPending}
                onClick={() => {
                  createCategory.mutate(
                    { name: newCatName.trim(), type: selectedType },
                    {
                      onSuccess: (created) => {
                        const id = str(asRecord(created).id);
                        if (id) form.setValue('categoryId', id);
                        setShowNewCategory(false);
                        setNewCatName('');
                      },
                    },
                  );
                }}
                style={primaryBtn}
              >
                {createCategory.isPending ? 'Salvando...' : 'Salvar categoria'}
              </button>
            </div>
          )}
          <Field label="Vencimento">
            <input {...form.register('dueDate')} type="date" style={inputCss} />
          </Field>
          <div
            style={{
              display: 'flex',
              gap: '0.5rem',
              justifyContent: 'flex-end',
              marginTop: '0.5rem',
            }}
          >
            <button type="button" onClick={onCancel} style={secondaryBtn}>
              Cancelar
            </button>
            <button type="button" onClick={onCreate} disabled={createPending} style={primaryBtn}>
              {createPending ? 'Criando...' : 'Criar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
